import React, { useEffect, useState, useRef } from "react";
import {

  StyleSheet,
  Image,
  TextInput,
  PDFDownloadLink,
  PDFViewer,
  pdf
} from "@react-pdf/renderer";
import { createRoot } from 'react-dom/client';
import Document from "../componets/pdf/Document";
import Page from "../componets/pdf/Page";
import View from "../componets/pdf/View";
import Text from "../componets/pdf/Text";
import Sign from "../componets/sign";
import EditableTextarea from '../componets/pdf/EditableTextarea'
import EditableInput from '../componets/pdf/EditableInput'
import EditableSelect from '../componets/pdf/EditableSelect'
import DownloadPDF from '../componets/pdf/DownloadPDF'
import NewContractDownload from '../componets/NewContractDownload'
import FileImage from '../componets/pdf/FileImage'
import { useNavigate, useParams, useLocation } from "react-router-dom";
import logo from "../images/PINSTACK.jpeg";
import logo2 from "../pinLogo2.png";
import API from "../utils/API";
import Button from "react-bootstrap/Button";
import { formatParagraphText } from "../utils/formatText";
import reactStringReplace from "react-string-replace";
import styles from "../styles/styles";
import PDFDownload from "../componets/PDFDownload";
import { generatePDFBlob } from "../utils/generatePDFBlob";
const logoBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAdCAYAAABumUQ7AAAACXBIWXMAAAsTAAALEwEAmpwYAAABXUlEQVRoge2YQQrCMAxFv5+K9EyhHqsWhUKQX+r92MKsOPUOE4Z+6Q0mdcYlzLuZcyz5+TklAjJRfprJYiBJmH/MAYiWaVWy3m4ljg9CggmnWWMx4DYhIm+HAbxy5iUE7xDAEKguHeAfjYI5YMgL4A9Wtwl9B+CoBRh4BUAfglQDwHzFcoB6TYfW1MDdpNVbsQ6QAxkYxmc0VyoIfBqShYPpAc0bqaMYeNzOKYNPPMg7OTUlULsJ47w6rfTRTyDdOtqG66L0VLbVZ0gRpAThzM4iTbU6ac9dNUlMZofD/kUCFoEyFAnUepqB8k1AgRAOIXMYEJrH9vUNX1bGv/4AD1WCLgJpm2cAAAAASUVORK5CYII=";


const initialContract = {
  ContractType: "",
  Client_Organization: "",
  BillingAddress: "",
  BookingContactEmail: "",
  BookingContactFullName: "",
  BookingContactPhone: "",
  EventDate: "",
  SiteContactFullName: "",
  GuestCount: "",
  Comments: "",
  Location: "",
  __PK_BEO_ID: "",
  LineTotal: 0,
  ServiceFeeTotal: 0,
  TaxTotal: 0,
  Total: 0,
  ContractTop: "",
  ContractBottom: "",
  signatureText: "",
  ContractSignDate: "",
  eventItems: [],
  eventPayments: [],
  resouceItems: [],
};

export default function NewContract({ pdfMode }) {
  const location = useLocation();
  const data = location.state?.contract; // <-- get the contract data

  const [contract, setContract] = useState({ data });
  const [signCreds, setSignCreds] = useState({});
  const [signedData, setSignedData] = useState({});
  const [sendingContract, setSendingContract] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [gotData, setGotData] = useState(false);
  const [signed, setSigned] = useState(false);
  const [retrieved, setRetrieved] = useState(true);
  const [msg, setMsg] = useState('Finalizing Contract...');
  const [cs, setCs] = useState(true);
  const [completed, setCompleted] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const inputRef = useRef([]);
  const signCredsRef = useRef({ name: "", initials: "" });
  const [shouldInitFill, setShouldInitFill] = useState(false);
  const [fieldValues, setFieldValues] = useState({});
  useEffect(() => {
    retrieveData();
    let clickHome = document.getElementById("homePhoto")
    clickHome.addEventListener('click', function () {
      // console.log("going home")
      navigate(`/${id}`);
    })

  }, []);
  useEffect(() => {
    if (signCreds.name && signCreds.initials) {
      // console.log("✅ signCreds updated:", signCreds);
      // Optional: auto scroll or trigger behavior here
    }

  }, [shouldInitFill]);
  useEffect(() => {
    // console.log(signedData)
  }, [signedData]);

  // Fetch contract data
  async function retrieveData() {
    setIsLoading(true);
    try {
      const res = await API.getContractData(id);
      if (res.messages?.[0]?.code === 401 || res.response.data[0].fieldData["Signed"] === 1) {
        navigate(`/${id}`);
        return;
      }
      const data = res.response.data[0];
      const contractObj = {
        "ContractType": res.response.data[0].fieldData["ContractType"],
        "Client_Organization": res.response.data[0].fieldData["AccountContacts::Client_Organization"],
        "AlcoholBEOTotalTax": res.response.data[0].fieldData["Alcohol BEOTotal Tax"],
        "AlcoholBEOTotal": res.response.data[0].fieldData["AlcoholBEOTotal"],
        "Balance": res.response.data[0].fieldData["Balance"],
        "BillingAddress": res.response.data[0].fieldData["Billing Address"],
        "BookingContactEmail": res.response.data[0].fieldData["BookingContactEmail"],
        "BookingContactFullName": res.response.data[0].fieldData["BookingContactFullName"],
        "BookingContactPhone": res.response.data[0].fieldData["BookingContactPhone"],
        "BowlingBEOTotalAll": res.response.data[0].fieldData["Bowling BEOTotal All"],
        "BowlingBEOTotal": res.response.data[0].fieldData["Bowling BEOTotal"],
        "BowlingBEOTotalServiceFeeLine": res.response.data[0].fieldData["Bowling BEOTotal ServiceFeeLine"],
        "BowlingBEOTotalTax": res.response.data[0].fieldData["Bowling BEOTotal Tax"],
        "ContractBottomBirthday": res.response.data[0].fieldData["ContractBottom Birthday"],
        "ContractBottomCE": res.response.data[0].fieldData["ContractBottom CE"],
        "ContractTopBirthday": res.response.data[0].fieldData["ContractTop Birthday"],
        "ContractTopCE": res.response.data[0].fieldData["ContractTop CE"],
        "Deposit": res.response.data[0].fieldData["Deposit"],
        "EquipmentBEOTotalAll": res.response.data[0].fieldData["Equipment BEOTotal All"],
        "EquipmentBEOTotal": res.response.data[0].fieldData["Equipment BEOTotal"],
        "EquipmentBEOTotalServiceFeeLine": res.response.data[0].fieldData["Equipment BEOTotal ServiceFeeLine"],
        "EquipmentBEOTotalTax": res.response.data[0].fieldData["Equipment BEOTotal Tax"],
        "EventContractTextBottomSE": res.response.data[0].fieldData["Event Contract Text Bottom SE"],
        "EventContractTextTopSE": res.response.data[0].fieldData["Event Contract Text Top SE"],
        "EventDate": res.response.data[0].fieldData["Event Date"],
        "EventEndDate": res.response.data[0].fieldData["Event End Date"],
        "EventTheme": res.response.data[0].fieldData["Event Theme"],
        "Comments": res.response.data[0].fieldData["Event comments::Comments"],
        "EventEndTime": res.response.data[0].fieldData["EventEndTime"],
        "EventStartTime": res.response.data[0].fieldData["EventStartTime"],
        "FoodBEOTotal": res.response.data[0].fieldData["FoodBEOTotal"],
        "FoodBEOTotalAll": res.response.data[0].fieldData["FoodBEOTotal All"],
        "FoodBEOTotalServiceFeeLine": res.response.data[0].fieldData["FoodBEOTotal ServiceFeeLine"],
        "FoodBEOTotalTax": res.response.data[0].fieldData["FoodBEOTotal Tax"],
        "FunBEOTotalAll": res.response.data[0].fieldData["Fun BEOTotal All"],
        "FunBEOTotal": res.response.data[0].fieldData["Fun BEOTotal"],
        "FunBEOTotalServiceFeeLine": res.response.data[0].fieldData["Fun BEOTotal ServiceFeeLine"],
        "FunBEOTotalTax": res.response.data[0].fieldData["Fun BEOTotal Tax"],
        "GuestCount": res.response.data[0].fieldData["Guest Count"],
        "EventsSignatures::INT1": res.response.data[0].fieldData["EventsSignatures::INT1"],
        "EventsSignatures::INT2": res.response.data[0].fieldData["EventsSignatures::INT2"],
        "EventsSignatures::INT3": res.response.data[0].fieldData["EventsSignatures::INT3"],
        "EventsSignatures::INT4": res.response.data[0].fieldData["EventsSignatures::INT4"],
        "EventsSignatures::INT5": res.response.data[0].fieldData["EventsSignatures::INT5"],
        "EventsSignatures::INT6": res.response.data[0].fieldData["EventsSignatures::INT6"],
        "EventsSignatures::INT7": res.response.data[0].fieldData["EventsSignatures::INT7"],
        "EventsSignatures::INT8": res.response.data[0].fieldData["EventsSignatures::INT8"],
        "EventsSignatures::INT9": res.response.data[0].fieldData["EventsSignatures::INT9"],
        "EventsSignatures::INT10": res.response.data[0].fieldData["EventsSignatures::INT10"],
        "EventsSignatures::INT11": res.response.data[0].fieldData["EventsSignatures::INT11"],
        "EventsSignatures::INT12": res.response.data[0].fieldData["EventsSignatures::INT12"],
        "EventsSignatures::INT13": res.response.data[0].fieldData["EventsSignatures::INT13"],
        "EventsSignatures::INT14": res.response.data[0].fieldData["EventsSignatures::INT14"],
        "EventsSignatures::INT15": res.response.data[0].fieldData["EventsSignatures::INT15"],
        "EventsSignatures::INT16": res.response.data[0].fieldData["EventsSignatures::INT16"],
        "EventsSignatures::INT17": res.response.data[0].fieldData["EventsSignatures::INT17"],
        "EventsSignatures::INT18": res.response.data[0].fieldData["EventsSignatures::INT18"],
        "EventsSignatures::INT19": res.response.data[0].fieldData["EventsSignatures::INT19"],
        "EventsSignatures::INT20": res.response.data[0].fieldData["EventsSignatures::INT20"],
        "LaborBEOTotalAll": res.response.data[0].fieldData["Labor BEOTotal All"],
        "LaborBEOTotal": res.response.data[0].fieldData["Labor BEOTotal"],
        "LaborBEOTotalServiceFeeLine": res.response.data[0].fieldData["Labor BEOTotal ServiceFeeLine"],
        "LaborBEOTotalTax": res.response.data[0].fieldData["Labor BEOTotal Tax"],
        "LineTotal": res.response.data[0].fieldData["Line Total"],
        "LiquorBEOTotalAll": res.response.data[0].fieldData["Liquor BEOTotal All"],
        "LiquorBEOTotalServiceFeeLine": res.response.data[0].fieldData["Liquor BEOTotal ServiceFeeLine"],
        "Location": res.response.data[0].fieldData["Location"],
        "PartyName": res.response.data[0].fieldData["Party Name"],
        "RetailBEOTotal": res.response.data[0].fieldData["Retail BEOTotal"],
        "RetailBEOTotalAll": res.response.data[0].fieldData["Retail BEOTotal All"],
        "RetailBEOTotalServiceFeeLine": res.response.data[0].fieldData["Retail BEOTotal ServiceFeeLine"],
        "RetailBEOTotalTax": res.response.data[0].fieldData["Retail BEOTotal Tax"],
        "RoomBEOTotalAll": res.response.data[0].fieldData["Room BEOTotal All"],
        "RoomBEOTotal": res.response.data[0].fieldData["Room BEOTotal"],
        "RoomBEOTotalServiceFeeLine": res.response.data[0].fieldData["Room BEOTotal ServiceFeeLine"],
        "RoomBEOTotalTax": res.response.data[0].fieldData["Room BEOTotal Tax"],
        "SalesRep": res.response.data[0].fieldData["SalesRep"],
        "SalesRep2": res.response.data[0].fieldData["SalesRep 2"],
        "ServiceFeeTotal": res.response.data[0].fieldData["ServiceFeeTotal"],
        "ServiceFeeTotalTax": res.response.data[0].fieldData["ServiceFeeTotal Tax"],
        "SignatureText": res.response.data[0].fieldData["signatureText"],
        "Signed": res.response.data[0].fieldData["Signed"],
        "SiteContactEmail": res.response.data[0].fieldData["SiteContactEmail"],
        "SiteContactFullName": res.response.data[0].fieldData["SiteContactFullName"],
        "SiteContactPhone": res.response.data[0].fieldData["SiteContactPhone"],
        "Status": res.response.data[0].fieldData["Status"],
        "SubTotalWSF": res.response.data[0].fieldData["SubTotalWSF"],
        "TaxTotal": res.response.data[0].fieldData["Tax Total"],
        "TerritoryName": res.response.data[0].fieldData["Territory Name"],
        "Total": res.response.data[0].fieldData["Total"],
        "TotalPerGuest": res.response.data[0].fieldData["Total Per Guest"],
        "emailHash": res.response.data[0].fieldData["emailHash"],
        "match": res.response.data[0].fieldData["match"],
        "__PK_BEO_ID": res.response.data[0].fieldData["__PK_BEO_ID"],
        "recordID": res.response.data[0].fieldData["recordID"],
        "eventItems": res.response.data[0].portalData.Event_Items,
        "eventPayments": res.response.data[0].portalData.EventPayments,
        "salesRepTerritory": res.response.data[0].fieldData["Territory 2::Sales Rep Primary"],
        "SalesRepEmail": res.response.data[0].fieldData["Territory 2::SalesRepEmail"],
        "resouceItems": res.response.data[0].portalData.EventResources

      };
      setContract(contractObj);
      setGotData(true);
      correctText(contractObj);
    } catch (error) {
      setRetrieved(false);
    } finally {
      setIsLoading(false);
    }
  }

  // Correct contract text based on type
  function correctText(contract) {
    // console.log('correct text')
    // console.log(contract)
    let contractObj = contract;
    //     console.log(contractObj.ContractType)
    // console.log(contractObj)
    if (contractObj.ContractType === 'CE') { console.log("in testing") }
    if (contractObj.ContractType === 'CE') {
      try {
        // console.log("in trying ce")
        let contractBottom;

        let contractTop;

        contractBottom = reactStringReplace(contractObj.ContractBottomCE, /(<<Location>>)/g, (match, i) => (
          <strong key={`location-${i}-${Math.random()}`}>{contractObj.Location}</strong>
        ))
        contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
          <br key={`br-${i}-${Math.random()}`} />)
        )
        contractTop = reactStringReplace(contractObj.ContractTopCE, /(<<Guest Count>>)/g, (match, i) => (
          <React.Fragment key={`guestcount-${i}-${Math.random()}`}>{contractObj.GuestCount}</React.Fragment>
        ))
        contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
          <React.Fragment key={`totalperguest-${i}-${Math.random()}`}>{contractObj.TotalPerGuest}</React.Fragment>
        ))
        contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
          <strong style={{ textDecoration: 'underline' }} key={`underline-${i}-${match}`}>{match}</strong>)
        )
        let boldString = `I agree to WAIVE LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
        contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
          <strong style={{ fontSize: '11px' }} key={`waive-${i}-${match}`}>{match}</strong>)
        )
        let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
        contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
          <strong style={{ fontSize: '10px' }} key={`terms-${i}-${match}`}>{match}</strong>)
        )

        // console.log(contractObj.eventItems.length)
        let eventFix;
        for (let e = 0; e < contractObj.eventItems.length; e++) {
          // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
          eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
            <br />)
          )
        }
        // console.log("got here");
        if (contractObj.ContractBottomCE) {
          const intMatches = contractObj.ContractBottomCE.match(/<<INT[0-9]+>>/g) || [];
          // console.log(intMatches.length);
          for (let c = 0; c < intMatches.length; c++) {
            let initV = "<<INT" + (c + 1) + ">>";
            // Get the field name as used in signedData
            let fieldName = initV.replace("<<", "EventsSignatures::").replace(">>", "");
            // Check if the value is empty
            const isEmpty = contractObj[`EventsSignatures::INT${c + 1}`].length === 0;
            contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (
              <EditableInput
                id={`init-${c}-${i}`}
                ref={i === 0 ? inputRef : null}
                className={`${isEmpty ? " input-border-empty" : "  text-center"}`}
                value={fieldValues[`EventsSignatures::INT${c + 1}`] || ""}
                readOnly={true}
                key={`init-${c}-${i}`}
                name={initV}
                size="5"
                onClick={(e) => initClick(e)}
                onBlur={(e) => checkInit(e)}
                onChange={() => { }}

              />

            ));
          }
        } else {
          // console.log("No ContractBottomCE found");
        }
        // console.log(contract)


        setContract({
          ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
        });


        setIsLoading(false)
        // console.log(isLoading)
      } catch (error) {
        // console.log(error)
        setGotData(false)

      }
    }
    else if (contractObj.ContractType === 'SE') {
      // console.log("se contract sfsaffsdfdf")
      try {
        let contractBottom;

        let contractTop;

        contractBottom = reactStringReplace(contractObj.EventContractTextBottomSE, /(<<Location>>)/g, (match, i) => (
          <strong key={`location-${i}-${Math.random()}`}>{contractObj.Location}</strong>
        ))
        contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
          <br key={`br-${i}-${Math.random()}`} />)
        )
        contractTop = reactStringReplace(contractObj.EventContractTextTopSE, /(<<Guest Count>>)/g, (match, i) => (
          <React.Fragment key={`guestcount-${i}-${Math.random()}`}>{contractObj.GuestCount}</React.Fragment>
        ))
        contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
          <React.Fragment key={`totalperguest-${i}-${Math.random()}`}>{contractObj.TotalPerGuest}</React.Fragment>
        ))
        contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
          <strong style={{ textDecoration: 'underline' }} key={`underline-${i}-${match}`}>{match}</strong>)
        )
        let boldString = `I agree to WAIVE LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
        contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
          <strong style={{ fontSize: '11px' }} key={`waive-${i}-${match}`}>{match}</strong>)
        )
        let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
        contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
          <strong style={{ fontSize: '10px' }} key={`terms-${i}-${match}`}>{match}</strong>)
        )

        // console.log(contractObj.eventItems.length)
        let eventFix;
        for (let e = 0; e < contractObj.eventItems.length; e++) {
          // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
          eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
            <br />)
          )
        }
        if (contractObj.EventContractTextBottomSE) {
          // console.log("contract se")
          const intMatches = contractObj.EventContractTextBottomSE.match(/<<INT[0-9]+>>/g) || [];
          // console.log(intMatches.length);
          for (let c = 0; c < intMatches.length; c++) {
            let initV = "<<INT" + (c + 1) + ">>";
            // Get the field name as used in signedData
            let fieldName = initV.replace("<<", "EventsSignatures::").replace(">>", "");
            // Check if the value is empty
            const isEmpty = contractObj[`EventsSignatures::INT${c + 1}`].length === 0;
            contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (
              <EditableInput
                id={`init-${c}-${i}`}
                ref={i === 0 ? inputRef : null}
                className={`${isEmpty ? " input-border-empty" : "  text-center"}`}
                value={fieldValues[`EventsSignatures::INT${c + 1}`] || ""}
                readOnly={true}
                key={`init-${c}-${i}`}
                name={initV}
                size="5"
                onClick={(e) => initClick(e)}
                onBlur={(e) => checkInit(e)}
                onChange={() => { }}

              />

            ));
          }
        } else {
          // console.log("No ContractBottomCE found");
        }
        // // console.log(contract)


        setContract({
          ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
        });


        setIsLoading(false)

      } catch (error) {
        // console.log(error)
        setGotData(false)

      }
    } else if (contractObj.ContractType === 'Birthday') {
      // console.log("se contract")
      try {
        let contractBottom;

        let contractTop;
        const uniqueKey = (prefix, index) => `${prefix}-${index}-${Math.random().toString(36).substr(2, 9)}`;

        contractBottom = reactStringReplace(contractObj.EventContractTextBottomSE, /(<<Location>>)/g, (match, i) => (
          <strong key={uniqueKey('location',i)}>{contractObj.Location}</strong>
        ))
        contractBottom = reactStringReplace(contractBottom, /(\r)/g, (match, i) => (
          <br key={uniqueKey('br',i)} />)
        )
        contractTop = reactStringReplace(contractObj.EventContractTextTopSE, /(<<Guest Count>>)/g, (match, i) => (
          <React.Fragment key={uniqueKey('guestcount',i)}>{contractObj.GuestCount}</React.Fragment>
        ))
        contractTop = reactStringReplace(contractTop, /(<<Total Per Guest>>)/g, (match, i) => (
          <React.Fragment key={uniqueKey('totalperguest',i)}>{contractObj.TotalPerGuest}</React.Fragment>
        ))
        contractBottom = reactStringReplace(contractBottom, /((?=-).*(?=:))/gs, (match, i) => (
          <strong style={{ textDecoration: 'underline' }} key={`underline-${i}-${match}`}>{match}</strong>)
        )
        let boldString = `I agree to WAIVE LIABILITY against and RELEASE PINSTACK FROM ANY LIABILITY ARISING FROM THE NEGLIGENCE, ERRORS or mistakes of its employees, agents, contractors, and/or other participants`
        contractBottom = reactStringReplace(contractBottom, boldString, (match, i) => (
          <strong style={{ fontSize: '11px' }} key={`waive-${i}-${match}`}>{match}</strong>)
        )
        let boldString2 = `I understand and agree to the terms and conditions listed above. Please review all event details for accuracy then sign, date and return to confirm acknowledgment of the agreement and contract.`
        contractBottom = reactStringReplace(contractBottom, boldString2, (match, i) => (
          <strong style={{ fontSize: '10px' }} key={`terms-${i}-${match}`}>{match}</strong>)
        )

        // console.log(contractObj.eventItems.length)
        let eventFix;
        for (let e = 0; e < contractObj.eventItems.length; e++) {
          // // console.log(contract.eventItems[e]["Event Food Items::Item Name Description"])
          eventFix = reactStringReplace(contractObj.eventItems[e]["Event Food Items::Item Name Description"], /(\r)/g, (match, i) => (
            <br />)
          )
        }
        if (contractObj.EventContractTextBottomSE) {
          // console.log("contract se")
          const intMatches = contractObj.EventContractTextBottomSE.match(/<<INT[0-9]+>>/g) || [];
          // console.log(intMatches.length);
          for (let c = 0; c < intMatches.length; c++) {
            let initV = "<<INT" + (c + 1) + ">>";
            // Get the field name as used in signedData
            let fieldName = initV.replace("<<", "EventsSignatures::").replace(">>", "");
            // Check if the value is empty
            const isEmpty = contractObj[`EventsSignatures::INT${c + 1}`].length === 0;
            contractBottom = reactStringReplace(contractBottom, initV, (match, i) => (
              <EditableInput
                id={`init-${c}-${i}`}
                ref={i === 0 ? inputRef : null}
                className={`${isEmpty ? " input-border-empty" : "  text-center"}`}
                value={fieldValues[`EventsSignatures::INT${c + 1}`] || ""}
                readOnly={true}
                key={`init-${c}-${i}`}
                name={initV}
                size="5"
                onClick={(e) => initClick(e)}
                onBlur={(e) => checkInit(e)}
                onChange={() => { }}

              />

            ));
          }
        } else {
          // console.log("No ContractBottomCE found");
        }

        setContract({
          ...contractObj, ContractBottom: contractBottom, ContractTop: contractTop
        });


        setIsLoading(false)
      } catch (error) {
        // console.log(error)
        setGotData(false)

      }
      // console.log("contract bottom")
      // console.log(contractObj)
    }



  }
  function checkInit(e) {
    // console.log('check init')
    // console.log(e)
    // console.log(e.target.value.length)
    if (e.target.value.length > 1) {
      if (e.target.id === "signature") {
        document.getElementById(e.target.id).classList.remove('backSignempty')
      }

      document.getElementById(e.target.id).classList.remove('input-border-empty')
      document.getElementById(e.target.id).classList.add('initialBox')
    }
    if (e.target.value.length < 1) {

      document.getElementById(e.target.id).classList.add('input-border-empty')

    }
    checkInputs()

  }



  const initClick = (e) => {
    const fieldName = e.target.name.startsWith('INT')
      ? `EventsSignatures::${e.target.name}`
      : e.target.name;

    // Use ref to get current value
    const currentCreds = signCredsRef.current;
    // console.log("Current creds in click:", currentCreds);
    // console.log(e.target.name)
    if (e.target.id === "signature") {
      if (!e.target.value && currentCreds.name) {
        e.target.value = currentCreds.name;
        setSignedData(prev => ({
          ...prev,
          ["EventsSignatures::" + fieldName + 'Text']: currentCreds.name
        }));

        checkInit(e)

      } else {
        let field = e.target.name.replace("<<", 'EventsSignatures::').replace(">>", '')
        setSignedData(prev => ({
          ...prev,
          [field]: e.target.value
        }));
      }

    } else {
      if (!e.target.value && currentCreds.initials) {
        e.target.value = currentCreds.initials;
        let field = e.target.name.replace("<<", 'EventsSignatures::').replace(">>", '')
        setSignedData(prev => ({
          ...prev,
          [field]: currentCreds.initials
        }));
      } else {
        setSignedData(prev => ({
          ...prev,
          [fieldName]: e.target.value
        }));
      }
    }
  };



  function checkInputs() {
    let inputs = document.getElementsByTagName('input');
    let input = [];
    for (let i = 0; i < inputs.length; ++i) {
      // console.log(inputs[i].value)

      // if (inputs[i].value.length > 1) {
      //     setCompleted(true)
      // }
      // if (inputs[i].value.length < 1) {
      //     setCompleted(false)
      input.push(inputs[i].value)
    }
    // // console.log('let input')
    // console.log(signedData)
    input.every(validateinputs)
  }


  function validateinputs(input) {
    // console.log('input.value')
    // console.log(input.value)
    // console.log(typeof input)

    if (typeof input === "undefined") {
      // console.log('undefined')
      setCompleted(false)
      return false
    }
    if (input === "") {
      setCompleted(false);
      return false
    }
    else {
      // console.log('validated ')
      setCompleted(true);
      return true
    }



  }
  const setFromChild = (data) => {
    // console.log("Setting sign creds:", data);
    setSignCreds({ name: data.name, initials: data.initials });
    signCredsRef.current = { name: data.name, initials: data.initials };
  };


  let goToSign = (index = 0) => {
    const el = document.getElementById('init-0-1');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
    checkInputs()

  }

  async function submitSignedContract(e) {
    setIsLoading(true)
    setSendingContract(true);

    // 1. Transform the signedData to proper FileMaker field names
    const fmData = {
      ...Object.entries(signedData).reduce((acc, [key, value]) => {
        if (key.startsWith('<<INT')) {
          const intNum = key.match(/\d+/)[0];
          acc[`EventsSignatures::INT${intNum}`] = value;
        }
        else if (key === 'signature') {
          acc['EventsSignatures::signatureText'] = value;
        }
        else {
          acc[key] = value;
        }
        return acc;
      }, {}),
      "EventsSignatures::Signed": 1,
      "ContractSignDate": new Date().toLocaleDateString()
    };

    try {
      // 2. Generate PDF using react-pdf's PDFDownloadLink

      // 3. Convert blob to base64
      const base64data = await generateContractPDF();

      // 4. Prepare FileMaker API payload
      const payload = {
        id,
        recordID: contract.recordID,
        evntID: contract.__PK_BEO_ID,
        repEmail: contract.SalesRepEmail,
        partyName: contract.PartyName,
        eventDate: contract.EventDate,
        signedData: fmData,
        pdfData: {
          filename: `Contract_${contract.__PK_BEO_ID}_${contract.PartyName}.pdf`,
          content: base64data
        }
      };

      // 5. Send to API
      const response = await API.postContract(payload);

      if (response.error) {
        throw new Error(response.message);
      }

      setMsg('Success!');
      setTimeout(() => navigate(`/${id}/contractview`), 2000);
    } catch (error) {
      console.error('Upload failed:', error);
      setCs(false);
      setMsg(`ERROR: ${error.message}`);
    } finally {
      setSendingContract(false);
    }
  }

  // PDF Generation using your existing component

  async function generateContractPDF() {
    return new Promise((resolve) => {
      // Create a temporary element
      const tempDiv = document.createElement('div');
      document.body.appendChild(tempDiv);

      // Use createRoot instead of render
      const root = createRoot(tempDiv);

      root.render(
        <PDFDownloadLink
          document={<NewContractDownload data={contract} pdfMode={true} />}
          fileName="contract.pdf"
        >
          {({ blob, url, loading, error }) => {
            if (blob) {
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = () => {
                // Clean up
                root.unmount();
                // document.body.removeChild(tempDiv);
                resolve(reader.result.split(',')[1]);
              };
            }
            return null;
          }}
        </PDFDownloadLink>
      );
    });
  }


  async function emailContract() {
    let data = contract
    await API.getSendEmail(data).then((res) => { console.log(res) })
  }
  function convertToStandardTime(timeString) {
    const timeParts = timeString.split(":");
    const hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
    const seconds = parseInt(timeParts[2], 10);

    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);

    return date.toLocaleTimeString(undefined, { hour: "numeric", minute: "numeric", hour12: true });
  }

  return (
    <div>
      <h1 className="text-light text-center">
        Contract for {contract.Client_Organization} on {contract.EventDate}
      </h1>
      {contract["EventsSignatures::Signed"] === 1 ? '<Sign />' :
        (
          ""
        )}

      {isLoading ? (
        <div className="text-center">
          {retrieved ? (
            <>
              <p>Loading...</p>
              <img src={logo2} className="App-logo" alt="logo" />
            </>
          ) : (
            <p>No Results Found. Please contact your PinStack Rep.</p>
          )}
        </div>
      ) : (
        <>
          {!pdfMode && contract.Signed != '1' ? (
            <div className="text-center mb-5">
              <Sign sign={data => setFromChild(data)} setsign={data => setSignCreds(data)} stat={contract.Status} />
              {cs ? <Button className="ms-2" variant="danger" onClick={() => goToSign()}> Begin Signing </Button> : ''}
            </div>
          ) : (<div className="text-center"><Button style={{ width: "150px" }} variant="secondary">
            <DownloadPDF fileName={contract.Client_Organization + '-' + contract.EventDate} data={contract} /></Button>




          </div>
          )}
          {signCreds && signCreds?.initials ? (
            <div className="mb-30" >
              <Document id="docu" pdfMode={pdfMode} className="mb-20">
                <Page id="docu" pdfMode={pdfMode} className="invoice-wrapper" size="A4"  >
                  {/* Header */}
                  <View pdfMode={pdfMode} className=" flex ">
                    <View pdfMode={pdfMode} className="w-50  ">
                      <FileImage pdfMode={pdfMode} className="logo" src={logoBase64} width={100} />
                    </View>
                    <View pdfMode={pdfMode} className="w-30  mk-10 right">
                      <View pdfMode={pdfMode} className="text-center">
                        <Text pdfMode={pdfMode} className="title contract-box text-center"  >Sales / Catering Contract</Text>
                        <View pdfMode={pdfMode} className="title contract-box text-center"  >
                          <Text pdfMode={pdfMode} style={styles.location}>{contract.Location} Location</Text>

                        </View>
                        <View pdfMode={pdfMode} style={styles.contractBox} className="border border-dark ps-2">

                          <Text pdfMode={pdfMode} style={styles.contractId}>{contract.__PK_BEO_ID}</Text>
                        </View>
                      </View>
                    </View>
                  </View>


                  {/* Client Info */}
                  <View pdfMode={pdfMode} className="info-row">
                    <View pdfMode={pdfMode} className="info-title flex">
                      <Text>Client Organization</Text>
                    </View>
                    <View pdfMode={pdfMode} className="info-title flex">
                      <Text>Event Date</Text>
                    </View>
                    <View pdfMode={pdfMode} className="info-title flex">
                      <Text>Phone</Text>
                    </View>
                    <View pdfMode={pdfMode} className="info-title flex">
                      <Text>Email</Text>
                    </View>
                  </View>

                  {/* Data Row */}
                  <View pdfMode={pdfMode} className="info-row">
                    <View pdfMode={pdfMode} className="info-cell flex">
                      <Text>{contract.Client_Organization}</Text>
                    </View>
                    <View pdfMode={pdfMode} className="info-cell flex">
                      <Text>{contract.EventDate}</Text>
                    </View>
                    <View pdfMode={pdfMode} className="info-cell flex">
                      <Text>{contract.BookingContactPhone}</Text>
                    </View>
                    <View pdfMode={pdfMode} className="info-cell flex">
                      <Text>{contract.BookingContactEmail}</Text>
                    </View>
                  </View>
                  <View pdfMode={pdfMode} className="info-row">
                    <View pdfMode={pdfMode} className="col info-title">
                      <Text>Address</Text>
                    </View>
                    <View pdfMode={pdfMode} className="col info-title">
                      <Text>Booking Contact</Text>
                    </View>
                    <View pdfMode={pdfMode} className="col info-title ">
                      <Text>Site Contact</Text>
                    </View>
                    <View pdfMode={pdfMode} className="col-auto  info-title ">
                      <Text>Guest</Text>
                    </View>
                  </View>
                  <View pdfMode={pdfMode} className={"info-row "}>
                    <View pdfMode={pdfMode} className={"info-cell col "}>
                      <Text>{contract.BillingAddress}</Text>
                    </View>
                    <View pdfMode={pdfMode} className={"info-cell col"}>
                      <Text>{contract.BookingContactFullName}</Text>
                    </View>
                    <View pdfMode={pdfMode} className={" info-cell col"}>
                      <Text>{contract.SiteContactFullName}</Text>
                    </View>
                    <View pdfMode={pdfMode} className="col-auto info-cell text-center">
                      <Text>{contract.GuestCount}</Text>
                    </View>
                  </View>
                  {/* Contract Top Text */}
                  <View pdfMode={pdfMode} style={styles.contractText}>
                    <Text className="fs-8">{contract.ContractTop}</Text>
                  </View>
                  {/* Event Items */}
                  <View>
                    <View pdfMode={pdfMode} className={"event-container border border-dark bg-gray"}>
                      <View pdfMode={pdfMode} className={"text-center"}>
                        <Text pdfMode={pdfMode} className=" fs-45 bold" >Event Items</Text>
                      </View>

                      <View pdfMode={pdfMode} className={"info-row items-header "}>
                        <Text pdfMode={pdfMode} className={"col-9"} >Food/Service Items</Text>
                        <Text pdfMode={pdfMode} className={"col-1"} >Price</Text>
                        <Text pdfMode={pdfMode} className={"col-1"} >Qty</Text>
                        <Text pdfMode={pdfMode} className={"col-1"} >Total</Text>
                      </View>
                    </View>
                    {contract.eventItems?.map((item, idx) => (
                      <View key={idx}>
                        <View pdfMode={pdfMode} className={"info-row items-row"}>
                          <Text pdfMode={pdfMode} className={"col-9"} >{item["Event Food Items::Display"]}</Text>
                          <Text pdfMode={pdfMode} className={"col-1"} >{item["Event Food Items::Item PriceUpdated"]}</Text>
                          <Text pdfMode={pdfMode} className={"col-1"} >{item["Event Food Items::ItemQty"]}</Text>
                          <Text pdfMode={pdfMode} className={"col-1"} >{item["Event Food Items::Line Total"]}</Text>
                        </View>

                        <View pdfMode={pdfMode} className={"item-description border fs-10"}>
                          {/* <Text>{item["Event Food Items::Item Name Description"]}</Text> */}
                          {formatParagraphText(item["Event Food Items::Item Name Description"], pdfMode)}

                        </View>
                      </View>
                    ))}
                  </View>
                  {/* Event Space */}
                  {contract.resouceItems?.length > 0 && (
                    <View>
                      <View pdfMode={pdfMode} className={"event-container border border-dark bg-gray"}>
                        <View pdfMode={pdfMode} className={"text-center"}>
                          <Text className={"fs-45 bold"}>Event Space</Text>
                        </View>
                        <View pdfMode={pdfMode} className={"info-row items-header"}>
                          <Text className="col-4">Event Space</Text>
                          <Text pdfMode={pdfMode} className="col-2 text-center">Start</Text>
                          <Text pdfMode={pdfMode} className="col-1">Bar</Text>
                          <Text pdfMode={pdfMode} className="col-1 text-center">Serving</Text>
                          <Text pdfMode={pdfMode} className="col-2 text-center">End</Text>
                          <Text pdfMode={pdfMode} className="col-2">Set Up Style</Text>
                        </View>
                      </View>
                      {contract.resouceItems.map((reso, idx) => (
                        <View key={idx}>
                          <View pdfMode={pdfMode} className={"info-row items-row"}>
                            <Text pdfMode={pdfMode} className={"col-4"}>{reso["Event Resources::ItemName"]}</Text>
                            <Text pdfMode={pdfMode} className={"col-2 text-center"}>{convertToStandardTime(reso["Event Resources::starting_time"])}</Text>
                            <Text pdfMode={pdfMode} className={"col-1 text-center"}>{reso["Event Resources::Bar"]}</Text>
                            <Text pdfMode={pdfMode} className={"col-1 text-center"}>{reso["Event Resources::Serving"]}</Text>
                            <Text pdfMode={pdfMode} className={"col-2 text-center"}>{convertToStandardTime(reso["Event Resources::ending_time"])}</Text>
                            <Text pdfMode={pdfMode} className={"col-2 text-center"}>{reso["Event Resources::SetupStyle"]}</Text>
                          </View>
                          <View pdfMode={pdfMode} className={"item-description border fs-10"}>
                            {/* <Text>{reso["Event Food Items::Item Name Description"]}</Text> */}
                            <Text>{reso["Event Food Items::Item Name Description"]}</Text>
                          </View>
                        </View>
                      ))}
                    </View>
                  )}
                  {/* Comments */}
                  <View pdfMode={pdfMode} style={[styles.itemsHeader, { marginTop: 10 }]}>
                    <View pdfMode={pdfMode} className={"event-container border border-dark bg-gray text-center"}>
                      <Text className={"fs-45 bold"}>Comments</Text>
                    </View>
                  </View>
                  <View pdfMode={pdfMode} className={"fs-12"}>
                    <Text>{contract.Comments}</Text>
                  </View>
                  {/* Totals */}
                  <View pdfMode={pdfMode} className="totals-container">
                    <View pdfMode={pdfMode} className="totals-table">
                      <View pdfMode={pdfMode} className="totals-row">
                        <Text pdfMode={pdfMode} className="totals-label">SubTotal</Text>
                        <Text pdfMode={pdfMode} className="totals-cell">${Number(contract.LineTotal).toFixed(2)}</Text>
                      </View>
                      <View pdfMode={pdfMode} className="totals-row">
                        <Text pdfMode={pdfMode} className="totals-label">Service Fee</Text>
                        <Text pdfMode={pdfMode} className="totals-cell">${Number(contract.ServiceFeeTotal).toFixed(2)}</Text>
                      </View>
                      <View pdfMode={pdfMode} className="totals-row">
                        <Text pdfMode={pdfMode} className="totals-label">Tax</Text>
                        <Text pdfMode={pdfMode} className="totals-cell">${Number(contract.TaxTotal).toFixed(2)}</Text>
                      </View>
                      <View pdfMode={pdfMode} className="totals-row totals-row-total">
                        <Text pdfMode={pdfMode} className="totals-label">Total</Text>
                        <Text pdfMode={pdfMode} className="totals-cell">${Number(contract.Total).toFixed(2)}</Text>
                      </View>
                    </View>
                  </View>
                  {/* Contract Bottom Text */}
                  <View pdfMode={pdfMode} style={styles.contractText}>
                    <Text>{contract.ContractBottom}</Text>
                  </View>
                  {/* Signature Section */}
                  <View className="signatureRow" pdfMode={pdfMode}>

                    <EditableInput className="signatureField input-border-empty col-4" pdfMode={pdfMode}
                      id="signature"
                      name="signature"
                      onClick={(e) => initClick(e)}
                      onBlur={(e) => checkInit(e)}
                      onChange={() => { }}>
                      {contract.SignatureText}
                    </EditableInput>


                    <Text className="bottomField col-4 " pdfMode={pdfMode}>
                      {contract.Signed === '1' ? (contract.ContractSignDate) : (new Date().toLocaleString())}
                    </Text>

                    <Text className="bottomField col-4 " id="printName" pdfMode={pdfMode}>
                      {contract.Signed === '1' ? (contract.SignatureText) : (signCredsRef.current.name)}
                    </Text>

                  </View>
                  <View className="signatureRow borderTop " pdfMode={pdfMode}>


                    <Text className="signatureLabel col-4" pdfMode={pdfMode}>Event Contact Signature</Text>



                    <Text className="signatureLabel col-4" pdfMode={pdfMode}>Date</Text>


                    <Text className="signatureLabel col-4" pdfMode={pdfMode}>Print Name</Text>

                  </View>
                  <View className="signatureRow" pdfMode={pdfMode}>
                    <View className="col" pdfMode={pdfMode}>
                      <Text className="bottomField bottomValue" pdfMode={pdfMode}>
                        {contract.Client_Organization}
                      </Text>
                      <Text className="bottomLabel" pdfMode={pdfMode}>Business Name</Text>
                    </View>

                    <View className="col" pdfMode={pdfMode}>
                      <Text className="bottomField bottomValue  " pdfMode={pdfMode}>
                        {contract.EventDate} {contract.EventStartTime}
                      </Text>
                      <Text className="signatureLabel" pdfMode={pdfMode}>Date & Time of Event</Text>
                    </View>
                  </View>
                  <View className="signatureRow mt-10 " pdfMode={pdfMode}>


                    <Text className="signatureLabel col-3" pdfMode={pdfMode}>Billing Address:<br />
                      6205 Dallas Parkway
                      Plano, TX 75024
                    </Text>

                    <Text className="signatureLabel col-3" pdfMode={pdfMode}>Pin Stack <br />
                      6205 Dallas Parkway
                      Plano, Texas 75024</Text>
                    <Text className="signatureLabel col-3" pdfMode={pdfMode}>{contract.SiteContactFullName} <br /> {new Date().toLocaleString()}</Text>

                  </View>
                </Page>
              </Document>

              <div className="text-center mt-3 mb-30">
                <div className="justify-content-center mt-3 mb-30">
                  {completed ? (<>

                    <div className="col"> </div>
                    <div  >
                      {cs ? <Button variant="danger" onClick={(e) => submitSignedContract(e)}>Submit Signed Contract</Button> : ''}
                    </div>    <div className="col"> </div></>
                  ) : ("")}
                </div>


              </div>
            </div>
          ) : ('')}


        </>
      )}
    </div>
  );
}